import { Paper } from "@mantine/core";
import { CustomerOfferHighlightEmbed } from "@/components/shared/CustomerOfferWhatWeOffer";
import {
  parseCustomerOfferHighlightsFromApi,
  type CustomerOfferHighlightApi,
} from "@/shared/constants/customerOfferPresets";

type WhatWeOfferCardProps = {
  value: CustomerOfferHighlightApi;
};

/** Standalone “What We Offer” panel — render directly below `CompanyHeaderCard`. */
export default function WhatWeOfferCard({ value }: WhatWeOfferCardProps) {
  const { presets, otherText } = parseCustomerOfferHighlightsFromApi(value);
  if (presets.length === 0 && !otherText.trim()) return null;

  return (
    <Paper
      py={8}
      px="sm"
      radius="lg"
      mb="md"
      bg="var(--mantine-color-primary-0)"
      style={{
        border: "1px solid var(--mantine-color-primary-2)",
        minWidth: 0,
        maxWidth: "100%",
        overflow: "visible",
      }}
    >
      <CustomerOfferHighlightEmbed value={value} />
    </Paper>
  );
}
